export const STATE_ACTIVE = 'ACTIVE';
